// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2g8nY","log":"ModalInventoryLogs_log__3l3jJ","date":"ModalInventoryLogs_date__2cLEX","userName":"ModalInventoryLogs_userName__3QlVX"};